/**
 * Product Title Translator
 * ------------------------
 * Translates .tt-title-small on product pages that Weglot does not
 * catch automatically.
 *
 * The element may load async (related products section), so on languageChanged
 * we retry until it appears in the DOM.
 */

'use strict';

function translateRelatedProductsTitle() {
  const element = document.querySelector('.tt-title-small');
  if (!element) return;
  
  const currentLang = Weglot.getCurrentLang();
  const originalText = element.getAttribute('data-original') || element.textContent.trim();
  
  // Save original Serbian text
  if (!element.hasAttribute('data-original')) {
    element.setAttribute('data-original', originalText);
  }
  
  // If Serbian, restore original
  if (currentLang === 'sr') {
    element.textContent = originalText;
    return;
  }
  
  // Translate to other languages
  Weglot.translate({
    words: [{ t: 1, w: originalText }],
    languageTo: currentLang
  }, data => {
    if (data[0]) element.textContent = data[0];
  });
}

// Wait for Weglot and setup
document.addEventListener('DOMContentLoaded', () => {
  const checkWeglot = setInterval(() => {
    if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
      clearInterval(checkWeglot);
      
      // Wait for element to appear
      const observer = new MutationObserver(() => {
        if (document.querySelector('.tt-title-small')) {
          observer.disconnect();
          translateRelatedProductsTitle();
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Check if element already exists
      if (document.querySelector('.tt-title-small')) {
        translateRelatedProductsTitle();
      }
      
      // On language change
      Weglot.on('languageChanged', translateRelatedProductsTitle);
    }
  }, 200);
});